import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { extendMembershipPeriod, updateMembershipGrade } from '../../lib/api/admin-membership-api';
import './MembershipModal.css';

function MembershipModal({ user, onClose, onUpdate }) {
  const { token } = useAuth();
  const [action, setAction] = useState('updateGrade'); // 'updateGrade' or 'extendPeriod'
  const [formData, setFormData] = useState({
    membershipType: user.membership?.membershipType || 'STARTER',
    months: 1,
    extendMonths: 1,
    memo: ''
  });
  const [loading, setLoading] = useState(false);

  const membershipTypes = [
    { value: 'STARTER', label: 'STARTER' },
    { value: 'STANDARD', label: 'STANDARD' },
    { value: 'DELUXE', label: 'DELUXE' },
    { value: 'PREMIUM', label: 'PREMIUM' }
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
      alert('인증 토큰이 없습니다. 다시 로그인해 주세요.');
      return;
    }

    setLoading(true);

    try {
      let response;

      if (action === 'updateGrade') {
        response = await updateMembershipGrade(token, {
          userId: user.id,
          membershipType: formData.membershipType,
          months: formData.months,
          memo: formData.memo
        });
      } else {
        if (!user.membership?.membershipId) {
          alert('활성 멤버십이 없습니다.');
          setLoading(false);
          return;
        }

        response = await extendMembershipPeriod(token, {
          membershipId: user.membership.membershipId,
          extendMonths: formData.extendMonths,
          memo: formData.memo
        });
      }
      if (response?.success) {
        alert(response.message);
        onUpdate();
      } else {
        alert(response?.message || '멤버십 변경에 실패했습니다.');
      }
    } catch (error) {
      console.error('멤버십 변경 실패:', error);
      alert(error?.message || '멤버십 변경 중 오류가 발생했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="membership-modal-overlay" onClick={onClose}>
      <div className="membership-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>멤버십 관리</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <div className="user-info">
            <p><strong>사용자:</strong> {user.userName} ({user.userId})</p>
            <p><strong>현재 멤버십:</strong> {user.membership?.membershipType || '없음'}</p>
            {user.membership && (
              <>
                <p><strong>시작일:</strong> {user.membership.startDate}</p>
                <p><strong>종료일:</strong> {user.membership.endDate}</p>
                <p><strong>상태:</strong> {user.membership.membershipStatus}</p>
              </>
            )}
          </div>

          <form onSubmit={handleSubmit}>
            <div className="action-selector">
              <label className="radio-label">
                <input
                  type="radio"
                  value="updateGrade"
                  checked={action === 'updateGrade'}
                  onChange={(e) => setAction(e.target.value)}
                />
                등급 변경
              </label>
              <label className="radio-label">
                <input
                  type="radio"
                  value="extendPeriod"
                  checked={action === 'extendPeriod'}
                  onChange={(e) => setAction(e.target.value)}
                  disabled={!user.membership}
                />
                기간 연장
              </label>
            </div>

            {action === 'updateGrade' ? (
              <>
                <div className="form-group">
                  <label>멤버십 유형</label>
                  <select
                    value={formData.membershipType}
                    onChange={(e) => setFormData({ ...formData, membershipType: e.target.value })}
                    required
                  >
                    {membershipTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label>기간 (개월)</label>
                  <input
                    type="number"
                    min="1"
                    max="120"
                    value={formData.months}
                    onChange={(e) => setFormData({ ...formData, months: parseInt(e.target.value) })}
                    required
                  />
                </div>
              </>
            ) : (
              <div className="form-group">
                <label>연장 기간 (개월)</label>
                <input
                  type="number"
                  min="1"
                  max="120"
                  value={formData.extendMonths}
                  onChange={(e) => setFormData({ ...formData, extendMonths: parseInt(e.target.value) })}
                  required
                />
              </div>
            )}

            <div className="form-group">
              <label>메모</label>
              <textarea
                value={formData.memo}
                onChange={(e) => setFormData({ ...formData, memo: e.target.value })}
                placeholder="변경 사유를 입력하세요"
                rows="3"
              />
            </div>

            <div className="modal-actions">
              <button type="button" onClick={onClose} className="btn-cancel">
                취소
              </button>
              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? '처리 중...' : '확인'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default MembershipModal;
